import router from '@/router';
import axios from 'axios'
import api from '@/services'
import {Account} from '@/api'
// import { Dialog } from 'vant';
class MdUtils {
  tokenKey = 'token'
  userInfoKey = 'u_info'
  keepAliveList = 'keepAliveList'

  clone(item) {
    return JSON.parse(JSON.stringify(item))
  }

  getStore(key) {
    return JSON.parse(localStorage.getItem(key))
  }

  setStore(key, val) {
    localStorage.setItem(key, JSON.stringify(val))
  }

  remove(key) {
    localStorage.removeItem(key)
  }

  setUserInfo(val) {
    this.setStore(this.userInfoKey, val)
  }

  getUserInfo(key) {
    let uInfo = this.getStore(this.userInfoKey) || {}
    return key ? uInfo[key] : uInfo
  }

  isLogin() {
    let id = this.getUserInfo('Id')
    if (!id ) {
      return false
    } else {
      return true
    }
  }

  setKeepAlive(list) {
    this.setStore(this.keepAliveList, list)
  }

  initKeepAlive() {
    let token = this.getTokenPack().AccessToken
    return token ?
      ['followArticle', 'home'] :
      ['home']
  }

  getKeepAlive() {
    return this.getStore(this.keepAliveList)
  }

  removeKeepAlive() {
    this.remove(this.keepAliveList)
  }

  commitRemoveKeepAlive(list) {
    let type = Object.prototype.toString.call(list)
    if (type === "[object Array]") {
      let keepAliveList = this.getStore('keepAliveList')
      let flag = keepAliveList.filter(item => {
        return !list.find(subItem => item === subItem)
      })
      this.setStore('keepAliveList', flag)
    }
  }

  randomString(L) {
    var s = ''
    var randomchar = () => {
      var n = Math.floor(Math.random() * 62)
      if (n < 10) return n // 1-10
      if (n < 36) return String.fromCharCode(n + 55) // A-Z
      return String.fromCharCode(n + 61) // a-z
    }
    while (s.length < L) s += randomchar()
    return s
  }
  UrlParamGet(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let index = window.location.href.indexOf('?');
    let r = window.location.href.substr(index + 1).match(reg);
    if (r) {
      // 操作 URI 中的“组成部分”应当使用 decodeURIComponent 会对参数中的保留字符（; / ? : @ & = + $ ,）进行转译
      return decodeURIComponent(r[2]);
    }
    return "";
  }
  wxLogOnAction(redirect = '') {
    if (this.isWeiXin()) {
      redirect = router.history.current.fullPath
      localStorage.setItem('wxRedirectUrl', redirect)
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_WX_APP_ID}&redirect_uri=${encodeURIComponent(process.env.VUE_APP_WX_REDIRECT_URL)}&response_type=code&scope=snsapi_userinfo&state=${encodeURIComponent(redirect)}&connect_redirect=1#wechat_redirect`;
    } else {
      router.push('/login')
      // window.location.href = '/login'
    }

    // if (process.env.VUE_APP_MD_ENV != 'production') {
    //   router.replace({ name: 'login' })
    // } else {
    //   window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
    //     process.env.VUE_APP_WX_APP_ID
    //     }&redirect_uri=${encodeURIComponent(
    //       process.env.VUE_APP_WX_REDIRECT_URL
    //     )}&response_type=code&scope=snsapi_userinfo&state=${encodeURIComponent(this.redirect)}&connect_redirect=1#wechat_redirect`;
    // }
  }

  MarkeStr(str, searchVal) {
    let key = searchVal.split(""); //拆分词
    let titleStr = str.replace(
      new RegExp(`[${key}]`, "ig"),
      s => `<span style='color:red'>${s}</span>`
    ); // g是global全局搜索 i是ignore case 忽略大小写
    return titleStr;
  }

  //判断是否是微信浏览器的函数
  isWeiXin() {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  }
  // 富文本添加水印
  adWaterMark(str) {
    if (!str) return ''
    let whiteList = [
      'img.51mydao.com'
    ]

    function isWhite(str) {
      let flag = false
      whiteList.forEach(url => {
        if (!flag && str.indexOf(url) >= 0) {
          flag = true
        }
      })
      return flag
    }

    // 获取img元素
    let nStr = str.replace(/<img[^>]{1,}>/g, (imgstr)=> {
      if (isWhite(imgstr)) {
        // 为src添加水印后缀
        return imgstr.replace(/(src=['"])([^'"]+)(['"])/, `$1$2${process.env.VUE_APP_IMG_WATER}$3 `)
      } else {
        return imgstr
      }
    })
    return nStr
  }

  tokenPackKey = "e_token_pack";
  isRefreshing = false;

  logOff() {
    this.clearInfo()
    this.wxLogOnAction()
  }

  clearInfo() {
    localStorage.removeItem(this.tokenPackKey);
    this.remove(this.tokenKey)
    this.remove(this.userInfoKey)
    this.removeKeepAlive()
  }

  getTokenPack() {
    let tokenPack = localStorage.getItem(this.tokenPackKey);
    if (tokenPack) {
      return JSON.parse(tokenPack);
    } else {
      return {
        AccessToken: "",
        RefreshToken: ""
      };
    }
  }

  setTokenPack(data) {
    localStorage.setItem(this.tokenPackKey, JSON.stringify(data));
  }

  RefreshTokenApi(data) {
    return api.request(Account.AccountRefreshToken, data, false, false);
  }

  async handleError0003(response) {
    try {
      if (this.isRefreshing) {
        // 加入延迟 待token刷新成功后操作
        await this.tryRequestIfRefreshing();
      } else {
        this.isRefreshing = true;
        await this.refreshToken();
      }

      return axios({
        method: "post",
        url: response.config.url,
        data: JSON.parse(response.config.data)
      }).then(res => {
        this.isRefreshing = false;
        return res;
      });
    } catch (error) {
      this.isRefreshing = false;
      this.logOff();
    }
  }

  refreshToken() {
    let data = this.getTokenPack();

    return this.RefreshTokenApi(data).then(res => {
      if (res) {
        this.setTokenPack(res);
      } else {
        throw new Error(res);
      }
    });
  }

  tryRequestIfRefreshing() {
    var tryTimes = 0;
    var maxTryTimes = 100;
    return new Promise((resolve, reject) => {
      var timer = setInterval(() => {
        if (tryTimes > maxTryTimes) {
          clearInterval(timer);
          reject();
        }
        ++tryTimes;
        if (!this.isRefreshing) {
          clearInterval(timer);
          resolve();
        }
      }, 100);
    });
  }
}

export default new MdUtils()